import { distinct } from "@/lib/hsUtil";

export default function HazardFilters({ rows, f, setF, prefix, showRisk = true }) {
  const set = k => e => setF(x => ({ ...x, [k]: e.target.value }));
  return (
    <div className="flex flex-wrap items-end gap-2">
      <input className="input !w-auto max-w-xs" placeholder="Search hazards" value={f.q} onChange={set("q")} data-testid={`${prefix}-search`}/>
      <select className="input !w-auto max-w-xs" value={f.phase} onChange={set("phase")} data-testid={`${prefix}-phase`}>
        <option value="">All build phases</option>
        {distinct(rows, "build_phase").map(p => <option key={p} value={p}>{p}</option>)}
      </select>
      {showRisk && (
        <select className="input !w-auto max-w-xs" value={f.risk} onChange={set("risk")} data-testid={`${prefix}-risk`}>
          <option value="">Any risk rating</option>
          {distinct(rows, "initial_risk", "residual_risk").map(r => <option key={r} value={r}>{r}</option>)}
        </select>
      )}
      {showRisk && (
        <select className="input !w-auto max-w-xs" value={f.flag} onChange={set("flag")} data-testid={`${prefix}-flag`}>
          <option value="">All hazards</option>
          <option value="swms">SWMS required</option>
          <option value="critical">Critical risk</option>
        </select>
      )}
    </div>
  );
}
